// ─── LOGIKA FINANSOWA ────────────────────────────────────────────────────────
// Opłacone prywatnie NIE zmniejsza salda od razu
// Saldo zmniejsza się dopiero przy faktycznej wypłacie ze zbiórki
// Zbiórki zwiększają saldo o faktycznie wpłaconą kwotę current_amount

export function calcBalance(expenses = [], settings = {}, collections = []) {
  const startBalance =
    Number(settings?.opening_balance ?? settings?.start_balance ?? 0);

  const totalPayout = expenses
    .filter((e) => e.status === "Wypłacone")
    .reduce((sum, e) => {
      const value = Number(e.payout_amount ?? e.total_value ?? 0);
      return sum + value;
    }, 0);

  const totalCollected = collections
    .filter((c) => c && c.current_amount != null)
    .reduce((sum, c) => {
      return sum + Number(c.current_amount ?? 0);
    }, 0);

  return startBalance + totalCollected - totalPayout;
}

export function calcTotalCollected(collections = []) {
  return collections.reduce((sum, c) => sum + Number(c.current_amount ?? 0), 0);
}

export function calcRealizedExpenses(expenses = []) {
  return expenses
    .filter(
      (e) =>
        e.status === "Wypłacone" ||
        e.status === "Zakupione / Nie wypłacone"
    )
    .reduce((sum, e) => sum + Number(e.total_value ?? 0), 0);
}

export function calcPlannedExpenses(planned = []) {
  return planned
    .filter((p) => p.status !== "Zrealizowane" && p.status !== "Anulowane")
    .reduce((sum, p) => sum + Number(p.amount ?? p.estimated_amount ?? 0), 0);
}

export function calcToReturn(expenses = []) {
  return expenses
    .filter((e) => e.status === "Zakupione / Nie wypłacone")
    .reduce((sum, e) => sum + Number(e.total_value ?? 0), 0);
}

export function calcForecast(balance = 0, plannedTotal = 0) {
  const result = Number(balance) - Number(plannedTotal);
  return { sufficient: result >= 0, surplus: result };
}

export function calculateAvailableAfterPlanned({
  currentBalance = 0,
  reimbursementAmount = 0,
  plannedExpensesTotal = 0,
} = {}) {
  return (
    Number(currentBalance ?? 0) -
    Number(reimbursementAmount ?? 0) -
    Number(plannedExpensesTotal ?? 0)
  );
}

export function formatPLN(value) {
  return new Intl.NumberFormat("pl-PL", {
    style: "currency",
    currency: "PLN",
  }).format(Number(value ?? 0));
}

export function formatDate(dateStr) {
  if (!dateStr) return "—";
  return new Intl.DateTimeFormat("pl-PL", {
    year: "numeric",
    month: "short",
    day: "numeric",
  }).format(new Date(dateStr));
}

export function statusColor(status) {
  switch (status) {
    case "Wypłacone":
      return "text-emerald-400 bg-emerald-400/10";
    case "Zakupione / Nie wypłacone":
      return "text-amber-400 bg-amber-400/10";
    case "Planowane":
      return "text-blue-400 bg-blue-400/10";
    case "Anulowane":
      return "text-red-400 bg-red-400/10";
    default:
      return "text-slate-400 bg-slate-400/10";
  }
}
